export default "__VITE_ASSET__3d5f2b0f__"